import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeMini } from '@at/design-system-foundation'

export const StyledFinanceDisclaimerText = styled(TypeMini)`
    & > a {
        border-bottom: none;
    }
    line-height: 1.8;
`

export const StyledLink = styled.span`
    ${({ theme }) => css`
        color: ${theme.color.text.link.default};
        border-bottom: solid 1px currentColor;
    `}
`

export const StyledSeparator = styled.span`
    ${({ theme }) => css`
        margin-right: ${ThemeSelectors.getLegacyGridUnit(theme) * 0.2}px;
    `}
`
